export enum Role {
  Agent = 'agent',
  Supervisor = 'supervisor',
  Administrator = 'administrator',
  TeamLeader = 'team_leader',
}
export enum RoleContext {
  Agent = 'Chuyên viên',
  Supervisor = 'Supervisor',
  Administrator = 'Administrator',
  TeamLeader = 'Trưởng bộ phận',
}
export class AgentConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên người dùng',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Email',
        key: 'email',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chức vụ',
        key: 'display_role',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Hoạt động',
        key: 'display_active',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static userRoleArray = () => {
    return [
      { id: Role.Agent, text: RoleContext.Agent },
      { id: Role.Supervisor, text: RoleContext.Supervisor },
      { id: Role.Administrator, text: RoleContext.Administrator },
      { id: Role.TeamLeader, text: RoleContext.TeamLeader },
    ];
  };
  static displayRoleColumns = (user, user_id) => {
    if (user._id === user_id) {
      return `<small class="badge badge-default">Là bạn</small>`;
    }
    switch (user.role) {
      case Role.Agent:
        return `<small class="badge badge-primary">` + RoleContext.Agent + `</small>`;
      case Role.Supervisor:
        return `<small class="badge badge-info">` + RoleContext.Supervisor + `</small>`;
      case Role.Administrator:
        return `<small class="badge badge-warning">` + RoleContext.Administrator + `</small>`;
      case Role.TeamLeader:
        return `<small class="badge badge-success">` + RoleContext.TeamLeader + `</small>`;
    }
  };
  static displayActiveColumns = data => {
    if (data.active) {
      return `<span class="text-success"><i class="icon fa fa-check-square-o" aria-hidden="true" style="font-size: 24px"></i></span>`;
    } else {
      return `<span class="text-secondary"><i class="icon fa fa-check-square-o" aria-hidden="true" style="font-size: 24px"></i></span>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/agent/agent.const.ts